import script from "./SuperadminSystemView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperadminSystemView.vue?vue&type=script&setup=true&lang=js"

import "./SuperadminSystemView.vue?vue&type=style&index=0&id=12d6d1ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d6d1ee"]])

export default __exports__